import { appReducer } from '../reducers/appReducer';
import { rightModalReducer } from '../reducers/rightModalReducer';
import { miniModalReducer } from '../reducers/miniModalReducer';
import { shopReducer } from '../modules/shop/reducers/shopReducer';
import { authReducer } from '../modules/auth/reducers/authReducer';
import { orderReducer } from '../modules/order/reducers/orderReducer';
import { pointsReducer } from '../modules/points/reducers/pointsReducer';
import { settingReducer } from '../modules/setting/reducers/settingReducer';
import { lendingReducer } from '../modules/lending/reducers/lendingReducer';
import { imagesReducer } from '../modules/images/reducers/imagesReducer';
import { configureStore } from '@reduxjs/toolkit';
import { landingAPI } from '../api';

const reducer = {
    appState: appReducer,
    lendingState: lendingReducer,
    authState: authReducer,
    pointsState: pointsReducer,
    shopState: shopReducer,
    orderState: orderReducer,
    rightModalState: rightModalReducer,
    miniModalState: miniModalReducer,
    settingState: settingReducer,
    imagesState: imagesReducer,
    [landingAPI.reducerPath]: landingAPI.reducer,
};

const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: false,
            serializableCheck: false,
        }).concat(landingAPI.middleware),
});

export { store };
